import React from 'react';
import { Controller, Control, RegisterOptions } from 'react-hook-form';
import { DeepMap } from 'react-hook-form/dist/types/utils';
import { TextField } from '@mui/material';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ConsumableItem } from 'api/consumablesApi';
import { EquipmentCategory } from 'api/equipmentApi';

interface Props {
  control?: Control;
  name: string;
  rules?: RegisterOptions;
  errors?: DeepMap<any, any>;
  label: string;
  items?: ConsumableItem[] | EquipmentCategory[];
  disabled?: boolean;
}

const RateCardFormItemAutoComplete = ({
  control,
  name,
  rules,
  errors,
  label,
  items,
  disabled,
}: Props) => {
  return (
    <Controller
      name={name}
      key={name}
      rules={rules}
      control={control}
      render={(props) => (
        <Autocomplete
          fullWidth
          autoHighlight
          autoSelect
          openOnFocus
          options={items}
          getOptionLabel={(option) => String(option?.name)}
          noOptionsText="No matches"
          value={items?.find((item) => item.id === props.value) || null}
          onChange={(_, data) => {
            const selectedId =
              data && typeof data === 'object' && 'id' in data ? data.id : null;
            props.onChange(selectedId);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!errors[name]}
              helperText={errors[name]?.message}
              label={label}
              variant="outlined"
              fullWidth
              disabled={disabled}
            />
          )}
        />
      )}
    />
  );
};

export default RateCardFormItemAutoComplete;
